import * as moment from "moment";
import * as React from 'react';
import CustomSelect from '../../common/CustomSelect';
import { withTheme } from '../../../common/withTheme';
import * as Configuration from '../../../configuration';
import { FilterState } from '../../../reducers/filter.reducer';
import { FilterSearchPropsAndActions } from "..";
import * as ReactDatetimeClass from "react-datetime";
import ClassificationSelect, { IClassificationSelectOption } from "../../Common/ClassificationSelect";

class FilterSearch extends React.PureComponent<FilterSearchPropsAndActions, any> {

    constructor(props, context) {
        super(props, context);

        var defaultDateRange = this.props.referenceData.dateRanges.find(r => Math.abs(Number(r.value)) == Math.abs(this.props.filter.defaultDateSpan));

        this.onDateRangeChanged = this.onDateRangeChanged.bind(this);
        this.onSelectedTimeChanged = this.onSelectedTimeChanged.bind(this);

        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.onEndDateChange = this.onEndDateChange.bind(this);
    }

    componentDidMount() {
        // this should all be refactored so we don't need to update filter on mount 
        // for mobile collapsed view which never mounts the form
        var newFilter: FilterState = { ...this.props.filter };

        let o: IClassificationSelectOption =  {
            value: undefined,
            label: "All data"
        };

        newFilter.selectedClassifications = o;
            

        this.props.updateFilters(newFilter);
    }

    onSelectedTimeChanged(time: IClassificationSelectOption) {
        var newFilter: FilterState = { ...this.props.filter };

        newFilter.selectedClassifications = time;

        this.props.updateFilters(newFilter);
    }

    onStartDateChange(date) {
        var startDate = moment(date ? date : this.props.filter.startDate)
            .startOf('day');

        var defaultDateSpan = startDate.diff(date, 'days');

        var newFilter: FilterState = { ...this.props.filter };

        newFilter.startDate = startDate;
        newFilter.defaultDateSpan = defaultDateSpan;

        if (newFilter.startDate > newFilter.endDate) {
            newFilter.endDate = undefined;
        }

        this.props.updateFilters(newFilter);
    }

    onEndDateChange(date) {
        var endDate = moment(date ? date : this.props.filter.endDate)
            .endOf('day');

        var defaultDateSpan = date.diff(endDate, 'days');

        var newFilter: FilterState = { ...this.props.filter };

        newFilter.endDate = endDate;
        newFilter.defaultDateSpan = defaultDateSpan;

        this.props.updateFilters(newFilter);
    }

    onDateRangeChanged(selectedDateSpan) {
        if (selectedDateSpan) {
            var startDate = moment()
                .add(selectedDateSpan.dateStartDifference, 'days')
                .startOf('day');

            var endDate = moment().endOf('day');

            var newFilter: FilterState = { ...this.props.filter };

            newFilter.endDate = endDate;
            newFilter.startDate = startDate;
            newFilter.selectedDateRange = selectedDateSpan;

            this.props.updateFilters(newFilter);
        } else {
            var newFilter: FilterState = { ...this.props.filter };

            newFilter.selectedDateRange = undefined;

            this.props.updateFilters(newFilter);
        }
    }

    render() {
        const { dateRanges } = this.props.referenceData;

        this.props.filter.defaultDateSpan

        //var yesterday = moment().subtract(1, 'day');
        var valid = function (current) {
            return current.isAfter(this.props.filter.startDate);
        };

        const dateFilter = <div className="col-12 my-2">
            <div className="d-flex justify-content-between align-items-center">
                <ReactDatetimeClass
                    className={"filter-date-calendar"}
                    onChange={this.onStartDateChange}
                    dateFormat={"DD/MM/YYYY"}
                    timeFormat={false}
                    inputProps={{
                        placeholder: "DD/MM/YYYY",
                        className: "form-control form-control-date",
                    }}
                    input={true}
                    value={this.props.filter.startDate}
                />
                <span className="mx-0">to</span>
                <ReactDatetimeClass
                    className={"filter-date-calendar"}
                    onChange={this.onEndDateChange}
                    dateFormat={"DD/MM/YYYY"}
                    timeFormat={false}
                    inputProps={{
                        placeholder: "DD/MM/YYYY",
                        className: "form-control form-control-date",

                    }}
                    input={true}
                    isValidDate={valid.bind(this)}
                    value={this.props.filter.endDate}
                />
            </div>
        </div>;

        const filterHeader =
            <div className="row">
                <div className="col-12 d-flex justify-content-between align-items-center">
                    <h6 className="m-0"><strong>{Configuration.custom.filterTitle}</strong></h6>
                </div>
            </div>;

        const primeTimeClassificationsValue = this.props.referenceData.classifications.filter(c => c.code == "Sunrise" || c.code == "Sunset")

        const timeClassificationOptions: IClassificationSelectOption[] = [
            {
                value: undefined,
                label: "All data"
            },
            {
                value: primeTimeClassificationsValue,
                label: "Prime Time Only"
            }
        ]

        const detailedFilterForm = <div className="row no-gutters mt-1">
            <div className="col-12">
                <ClassificationSelect
                    label="Time Of Day"
                    className="my-1 form-control-small"
                    options={timeClassificationOptions}
                    value={this.props.filter.selectedClassifications}
                    onChange={this.onSelectedTimeChanged}
                />
            </div>
        </div>;

        return (
            this.props.show ?
                <div className="bg-white p-3 rounded">
                    {filterHeader}
                    <div className="row no-gutters mt-1">
                        <div className="col-12">
                            <CustomSelect
                                label="Date Period"
                                placeholder=""
                                className="my-1 form-control-small"
                                options={dateRanges}
                                value={this.props.filter.selectedDateRange}
                                onChange={this.onDateRangeChanged}
                            />
                        </div>
                        {this.props.filter && this.props.filter.selectedDateRange && this.props.filter.selectedDateRange.value === "custom" ? dateFilter : undefined}
                    </div>
                    {detailedFilterForm}
                </div>
                : <span></span>
        );
    }
}

export default withTheme<FilterSearchPropsAndActions>(FilterSearch);
